import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { WidgetTemplate } from '../../models/widget/widget-template.model';
import { Observable } from 'rxjs/Observable';
import { WithdrawalsPurchaseOrder } from "../../models/Withdrawals/withdrawals-purchase-order.models";
import { WithDrawalsViewModel } from "../../models/Withdrawals/withdrawals-view";
import { WithdrawalsViews } from "../../models/Withdrawals/withdrawals-view.models";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class WithdrawlsService {
  private service = "api/Finance"; //Controller Name
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  // Region Widget Template

  GetWithdrawalDetails(id: number) {
    return this.http.get(`${this.service}/GetWithdrawalDetails?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateWithDrawal(model: WithDrawalsViewModel) {
    return this.http
      .post(`${this.service}/UpdateWithDrawal`, model, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response)
      .catch(this.errorHandler);
  }
  GetWithDrawalRequestByID(id: number) {
    return this.http.get(`${this.service}/GetWithDrawalRequestByID?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetWithDrawalRequestByStatus(statusID: number) {
    return this.http.get(`${this.service}/GetWithDrawalRequestByStatus?statusID=` + statusID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetWithDrawalRequest() {
    return this.http.get(`${this.service}/GetWithDrawalRequest`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  // End Region Widget Template
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/withdrawls/withdrawls.service.ts